var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-search",
    "data-name": "Icon ionic-ios-search",
    d: "M29.207,27.683l-6.953-7.016a9.909,9.909,0,1,0-1.5,1.523l6.907,6.971a1.07,1.07,0,0,0,1.51.039A1.077,1.077,0,0,0,29.207,27.683ZM14.467,22.275A7.823,7.823,0,1,1,20,19.984,7.777,7.777,0,0,1,14.467,22.275Z",
    transform: "translate(-4.5 -4.493)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4cf90357d6ae0075b8bde9cdd0f8829b.svg";
export { ForwardRef as ReactComponent };